<template>
	<div id="searchBox">
		<div class="mapGoogle" id="map"></div>
		<input id="pac-input" class="controls" type="text" placeholder="Search Box" :autofocus='focus'>
		<span v-if="showSearch" class="sure" @click="sureBox">选择当前地址</span>
	</div>
</template>

<script>
	import constants from '@/util/constants.js';
	import coordtransform from './coordtransform.js';
	import axios from 'axios';	
	export default {
		data() {
			return {
				lngtxt:'',
				lattxt:'',
				addresstxt:'',
				map:null,
				marker:null,
				infowindow:null,
				geocoder:null,
				markersArray:[],
				searchText:'',
				focus:false,
				searchBox:null,
				addrText:{},
				addrCode:{},
				gpsGetData:{},
				inputText:'',//搜索
				showSearch:true
			}
		},
		methods: {
			init() { //初始化地图
					var _this=this;
				  // var center ={lat: this.lngtxt, lng: this.lattxt};
				  var latlng = new google.maps.LatLng(this.lngtxt, this.lattxt)
				  var myOptions = {
					zoom: 16,
					center: latlng,
					gestureHandling: 'greedy',
					mapTypeId: google.maps.MapTypeId.ROADMAP
				};
				this.map = new google.maps.Map(document.getElementById('map'), myOptions);
				this.geocoder = new google.maps.Geocoder();//实例化地址解析
				//监听点击地图事件
				google.maps.event.addListener(_this.map, 'click', function (event) {
					_this.placeMarker(event.latLng);
				});
				// Create the search box and link it to the UI element.
				var input = document.getElementById('pac-input');
				this.searchBox = new google.maps.places.SearchBox(input);
				this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
				// console.log(places)
				// Bias the SearchBox results towards current map's viewport.
				this.map.addListener('bounds_changed', function() {
				   _this.searchBox.setBounds(_this.map.getBounds());
				});

				
				// Listen for the event fired when the user selects a prediction and retrieve
				// more details for that place.
				this.searchBox.addListener('places_changed', function() {
					_this.searchEnter()
				});
				google.maps.event.addListener(this.map, 'dragend',  
				function() { 
			        if(_this.map)
			        {
			          var maxX = _this.map.getBounds().getNorthEast().lng();
			          var maxY = _this.map.getBounds().getNorthEast().lat();
			          var minX = _this.map.getBounds().getSouthWest().lng();
			          var minY = _this.map.getBounds().getSouthWest().lat();
			          if (maxY > 85.2 || minY < -85){
			            _this.map.panTo(new google.maps.LatLng(35.05859375, 0.580078125));
			            return;
			          }
			        }
				});					
			},
			searchEnter(){
				var markers = [];
				var _this=this
				  var places = this.searchBox.getPlaces();
				  
					if(!places) return
				  if (places.length == 0) {
					return;
				  }

				  // Clear out the old markers.
				  markers.forEach(function(marker) {
					marker.setMap(null);
				  });
				  markers = [];

				  // For each place, get the icon, name and location.
				  var bounds = new google.maps.LatLngBounds();
				  places.forEach(function(place) {
					if (!place.geometry) {
					  console.log("Returned place contains no geometry");
					  return;
					}
					var url=''
					var icon = {
					  url: place.icon,
					  size: new google.maps.Size(71, 71),
					  origin: new google.maps.Point(0, 0),
					  anchor: new google.maps.Point(17, 34),
					  scaledSize: new google.maps.Size(25, 25)
					};
					//console.log(place.geometry.location.lat());
					_this.mapClick(place.geometry.location.lng(),place.geometry.location.lat(),place.name);
					// Create a marker for each place.
					markers.push(new google.maps.Marker({
					  map: _this.map,
					  icon: icon,
					  title: place.name,
					  position: place.geometry.location
					}));

					if (place.geometry.viewport) {
					  // Only geocodes have viewport.
					  bounds.union(place.geometry.viewport);
					} else {
					  bounds.extend(place.geometry.location);
					}
				  });
				  this.map.fitBounds(bounds);				
			},
			 placeMarker(location) {
				 var _this=this;
				this.clearOverlays(this.infowindow);//清除地图中的标记
				var marker = new google.maps.Marker({
					position: location,
					map: _this.map
				});
				this.markersArray.push(marker);
				//根据经纬度获取地址
				if (this.geocoder) {
					this.geocoder.geocode({ 'location': location }, function (results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							if (results[0]) {
								_this.attachSecretMessage(marker, results[0].geometry.location, results[0].formatted_address);
							}
						} else {
							alert("Geocoder failed due to: " + status);
						}
					});
				}
			},
			//在地图上显示经纬度地址
			attachSecretMessage(marker, piont, address) {
				var message = "<b>坐标:</b>" + piont.lat() + " , " + piont.lng() + "<br />" + "<b>地址:</b>" + address;
				this.infowindow = new google.maps.InfoWindow(
					{
						content: message,
						size: new google.maps.Size(50, 50)
					});
				this.infowindow.open(this.map, marker);
				if (typeof (this.mapClick) == "function") this.mapClick(piont.lng(), piont.lat(), address);
			},
			    //删除所有标记阵列中消除对它们的引用
			clearOverlays(infowindow) {
			    if (this.markersArray && this.markersArray.length > 0) {
			        for (var i = 0; i < this.markersArray.length; i++) {
			            this.markersArray[i].setMap(null);
			        }
			       this.markersArray.length = 0;
			    }
			    if (infowindow) {
			        infowindow.close();
			    }
			},
			setiInit() {
				var _this=this;
				// 页面加载显示默认lng lat address---begin
				if (this.lattxt != '' && this.lngtxt != '' && this.addresstxt != '') {
					var latlng = new google.maps.LatLng(this.lattxt, this.lngtxt);
					var marker = new google.maps.Marker({
						position: latlng,
						map: _this.map
					});
					this.markersArray.push(marker);
					this.attachSecretMessage(marker, latlng, this.addresstxt);
				}
				// ---end
			},
			mapClick(lng, lat, address) {
				this.addrText={lng, lat, address}
				var inputBox = document.getElementById('pac-input');
				inputBox.value=address;
				// this.tagClick(lng,lat)
			},		
			parendZx(){
				this.searchText=this.$route.query.hit;
				axios.get('http://admin.chnn.dajiuxing.com.cn/admin/order/searchAddr',{
					params:{
						hit:this.$route.query.hit
					}
				})
				.then(res => {
					var inputBox = document.getElementById('pac-input');
					if(res.data.obj == undefined) {
						
						this.$message.error('未搜索到指定地址，请手动搜索！');
					}else{
						this.gpsGetData=res.data.obj
						this.addresstxt=res.data.obj.addr;
						this.lattxt=res.data.obj.latitude;
						this.lngtxt=res.data.obj.longitude;
						this.map.setCenter(new google.maps.LatLng(this.lattxt, this.lngtxt))
						this.setiInit()
					}
					inputBox.value=this.searchText;
					setTimeout(() => {
						inputBox.focus()
					},1000)
				})
				.catch(err => {
					console.log(err)
				})			
			},
			sureBox(){
				if(this.addrText.address == undefined){
					this.addrText={lng:this.lattxt, lat:this.lngtxt, address:this.addresstxt}
				}
				axios.get('http://admin.chnn.dajiuxing.com.cn/admin/order/getGpsInfo',{
					params:{
						addr:this.addresstxt,
						latitude:this.lngtxt,
						longitude:this.lattxt
					}
				})
				.then( res => {
				    console.log(res);
					if(res.data.code == 0){
						
					}
				})
				.catch(err => {
				    console.log(err);
				})
			},
			tagClick(lng, lat){
				var data={
					lng,
					lat
				}
				searchAddrByGps(data)
				.then(res => {
					this.gpsGetData=res.data.obj;	
				})
				.catch(err => {
					console.log(err)
				})					
			}
		},
		mounted() {
			var timer =setInterval(() => {
				if(typeof google == 'object'){
					clearInterval(timer)
					this.init();
					console.log(this.$route.query.hit)
					this.parendZx(this.$route.query.hit)
				}
			},300)
		},
		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		}
		
	}
</script>
<style>
	body,
	html {
		height: 100%;
		width: 100%;
	}

	#app {
		height: 100%;
		width: 100%;
	}
	.gm-style-mtc ,.gm-svpc{display: none;}
	.gm-control-active,.gm-fullscreen-control{display: none;}	
</style>
<style scoped="scoped">
	#searchBox {
		width: 100%;
		height: 100%;
	}

	#map {
		width: 100%;
		height: 100%;
	}
	#pac-input{
		background-color: #fff;
		font-family: Roboto;
		font-size: 15px;
		font-weight: 300;
		margin-left: 12px;
		padding: 0 11px 0 13px;
		text-overflow: ellipsis;
		width: 300px;
		height: 30px;line-height: 30px;
		margin-top: 5px;
	}
	.sure{position: absolute;top: 5px;left: 380px;display: inline-block;padding: 0 20px;background-color: #00ABF9;color: white;line-height: 32px;cursor: pointer;}
	.close{position: absolute; top: 10px;right: 10px;width: 30px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/views/map/searchMapGPS.vue